import api from '../../../../services/api';

const authHeader = () => ({});

// Unidades
export const getUnidades = async () => {
  const res = await api.get('/checklist/unidades', { headers: authHeader() });
  return res.data;
};
export const getUnidade = async (id) => {
  const res = await api.get(`/checklist/unidades/${id}`, { headers: authHeader() });
  return res.data;
};
export const saveUnidade = async (data) => {
  if (data.unidade_id) {
    const res = await api.put(`/checklist/unidades/${data.unidade_id}`, data, { headers: authHeader() });
    return res.data;
  } else {
    const res = await api.post('/checklist/unidades', data, { headers: authHeader() });
    return res.data;
  }
};
export const deleteUnidade = async (id) => {
  await api.delete(`/checklist/unidades/${id}`, { headers: authHeader() });
};

// Modelos
export const getModelos = async () => {
  const res = await api.get('/checklist/modelos', { headers: authHeader() });
  return res.data;
};
export const getModelo = async (id) => {
  const res = await api.get(`/checklist/modelos/${id}`, { headers: authHeader() });
  return res.data;
};
export const saveModelo = async (data) => {
  if (data.id) {
    const res = await api.put(`/checklist/modelos/${data.id}`, data, { headers: authHeader() });
    return res.data;
  } else {
    const res = await api.post('/checklist/modelos', data, { headers: authHeader() });
    return res.data;
  }
};
export const deleteModelo = async (id) => {
  await api.delete(`/checklist/modelos/${id}`, { headers: authHeader() });
};

// Execuções
export const getExecucoes = async () => {
  const res = await api.get('/checklist/execucoes', { headers: authHeader() });
  return res.data;
};
export const getExecucao = async (id) => {
  const res = await api.get(`/checklist/execucoes/${id}`, { headers: authHeader() });
  return res.data;
};
export const createExecucao = async (data) => {
  const res = await api.post('/checklist/execucoes', data, { headers: authHeader() });
  return res.data;
};
export const responderPerguntas = async (id, respostas) => {
  const res = await api.post(`/checklist/execucoes/${id}/respostas`, respostas, { headers: authHeader() });
  return res.data;
};
export const finalizarExecucao = async (id) => {
  const res = await api.put(`/checklist/execucoes/${id}/finalizar`, {}, { headers: authHeader() });
  return res.data;
};

export const deleteExecucao = async (id) => {
  await api.delete(`/checklist/execucoes/${id}`, { headers: authHeader() });
};

// Plano de Ação
export const getPlanos = async () => {
  const res = await api.get('/checklist/planos-acao', { headers: authHeader() });
  return res.data;
};
export const savePlano = async (data) => {
  if (data.plano_acao_id) {
    const res = await api.put(`/checklist/planos-acao/${data.plano_acao_id}`, data, { headers: authHeader() });
    return res.data;
  } else {
    const res = await api.post('/checklist/planos-acao', data, { headers: authHeader() });
    return res.data;
  }
};

// Agendamentos
export const getAgendamentos = async () => {
  const res = await api.get('/checklist/agendamentos', { headers: authHeader() });
  return res.data;
};
export const saveAgendamento = async (data) => {
  if (data.id) {
    const res = await api.put(`/checklist/agendamentos/${data.id}`, data, { headers: authHeader() });
    return res.data;
  } else {
    const res = await api.post('/checklist/agendamentos', data, { headers: authHeader() });
    return res.data;
  }
};
export const deleteAgendamento = async (id) => {
  await api.delete(`/checklist/agendamentos/${id}`, { headers: authHeader() });
};

// IA
export const analiseVisual = async (data) => {
  const res = await api.post('/checklist/ia/analise-visual', data, { headers: authHeader() });
  return res.data;
};
export const gerarChecklist = async (data) => {
  const res = await api.post('/checklist/ia/gerar-checklist', data, { headers: authHeader() });
  return res.data;
};

// Configurações - contatos WhatsApp
export const getContatos = async () => {
  const res = await api.get('/checklist/contatos-whatsapp', { headers: authHeader() });
  return res.data;
};
export const saveContato = async (data) => {
  if (data.id) {
    const res = await api.put(`/checklist/contatos-whatsapp/${data.id}`, data, { headers: authHeader() });
    return res.data;
  } else {
    const res = await api.post('/checklist/contatos-whatsapp', data, { headers: authHeader() });
    return res.data;
  }
};
export const deleteContato = async (id) => {
  await api.delete(`/checklist/contatos-whatsapp/${id}`, { headers: authHeader() });
};
